import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'shared/hooks/store';
import { useStudent } from 'shared/hooks/user/useStudent';
import { useUserRole } from 'shared/hooks/user/useUserRole';
import { adminActions } from 'shared/store/admin';
import { UserRole } from 'shared/types';
import { matchRouteNotStrict } from 'shared/utils/router';

import { ADMIN_ROUTES } from './constants';

export const useIsAdminView = () => {
  const { isAdminView } = useAppSelector(({ admin }) => admin);
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const role = useUserRole();
  const student = useStudent();

  useEffect(() => {
    dispatch(
      adminActions.setIsAdminView(
        ADMIN_ROUTES.every(route => !matchRouteNotStrict(route)) &&
          (role === UserRole.Staff || role === UserRole.Admin) &&
          Boolean(student),
      ),
    );
  }, [dispatch, pathname, role, student]);

  return isAdminView;
};
